import './PlatformSidebarMenuItems.css';
import { useNavigate, useLocation } from "react-router-dom";
import the402logo from './the402logo.png';
import { MdOutlineExplore } from "react-icons/md";
import { BsMusicNoteBeamed } from "react-icons/bs";
import { AiOutlineShop } from "react-icons/ai";
import { CgProfile } from "react-icons/cg";
import logo from "./logo.png";

function PlatformSidebarMenuItems(props) {
  const navigate = useNavigate();
  const location = useLocation();
  function handleClickMarketplace() {
    navigate("/market")
  }
  function handleClickVideos() {
    navigate("/explore")
  }
  function handleClickHome() {
    navigate("/")
  }
  { /* function handleClickMusic() {
    navigate("/music")
  } */ }
  function handleClickUpload() {
    navigate("/upload")
  }
  function handleClickMyNFTs() {
    navigate("/myNFTs")
  }

  function handleClickBuild() {
    navigate("/build")
  }

  function handleClickAuction() {
    navigate("/auctioncollections")
  }

  return (
    <div className="flex items-center">
      <div className="sm:h-8 sm:w-8 h-6 w-6 ml-2 sm:ml-10 cursor-pointer" onClick = {handleClickHome}>
        <img src={logo}/>
      </div>
      <div className = {location.pathname === "/" ? "ml-2 text-xs md:text-xs lg:text-base sm:ml-10 font-semibold text-gray-800 dark:text-gray-100 cursor-pointer" : "ml-2 sm:ml-10 text-xs md:text-xs lg:text-base font-medium text-gray-600 dark:text-gray-400 cursor-pointer"} onClick = {handleClickHome}>
        <div className="px-1 md:hidden text-xl flex items-center justify-center">
          <MdOutlineExplore/>
        </div>
        <div className="hidden md:flex items-center justify-center">
          Explore
        </div>
      </div>
      { /* <div className = {location.pathname === "/music" ? "ml-2 text-xs md:text-xs lg:text-base sm:ml-10 font-semibold text-gray-800 dark:text-gray-100 cursor-pointer" : "ml-2 sm:ml-10 text-xs md:text-xs lg:text-base font-medium text-gray-600 dark:text-gray-400 cursor-pointer"} onClick = {handleClickMusic}>
        <div className="px-2 md:hidden text-xl flex items-center justify-center">
          <BsMusicNoteBeamed/>
        </div>
        <div className="hidden md:flex items-center justify-center">
          Music
        </div>
      </div> */ }
      <div className = {location.pathname === "/auctioncollections" || location.pathname === "/nounsupload" || location.pathname.includes("/auction/") ? "ml-2 text-xs md:text-xs lg:text-base sm:ml-10 font-semibold text-gray-800 dark:text-gray-100 cursor-pointer" : "ml-2 sm:ml-10 text-xs md:text-xs lg:text-base font-medium text-gray-600 dark:text-gray-400 cursor-pointer"} onClick = {handleClickAuction}>
        <div className="px-1 md:hidden text-sm flex items-center justify-center">
          ⌐◨-◨
        </div>
        <div className="hidden md:flex items-center justify-center">
          ⌐◨-◨
        </div>
      </div>
      { /*
      <div className = {location.pathname === "/myNFTs" ? "ml-2 text-xs md:text-xs lg:text-base sm:ml-10 font-semibold text-gray-800 dark:text-gray-100 cursor-pointer" : "ml-2 sm:ml-10 text-xs md:text-xs lg:text-base font-medium text-gray-600 dark:text-gray-400 cursor-pointer"} onClick = {handleClickMyNFTs}>
        <div className="px-1 md:hidden text-xl flex items-center justify-center">
          <CgProfile/>
        </div>
        <div className="hidden md:flex items-center justify-center">
          My NFTs
        </div>
      </div>
      */ }
      <div className = {location.pathname === "/market" ? "ml-2 text-xs md:text-xs lg:text-base sm:ml-10 font-semibold text-gray-800 dark:text-gray-100 cursor-pointer" : "ml-2 sm:ml-10 text-xs md:text-xs lg:text-base font-medium text-gray-600 dark:text-gray-400 cursor-pointer"} onClick = {handleClickMarketplace}>
        <div className="px-1 md:hidden text-xl flex items-center justify-center">
          <AiOutlineShop/>
        </div>
        <div className="hidden md:flex items-center justify-center">
          Marketplace
        </div>
      </div>
    </div>
  );
}

export default PlatformSidebarMenuItems;
